exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App {\n\ttext-align: center;\n}\n\n.App-header {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-pack: center;\n\t    justify-content: center;\n\t-ms-flex-align: center;\n\t    align-items: center;\n\tpadding: 10px 0;\n\tbackground-color: #222;\n\tcolor: #fff;\n}\n\n.App-tv-logo {\n\theight: 45px;\n}\n\n.App-react-logo {\n\tdisplay: block;\n\theight: 62px;\n}\n\n.App-title {\n\tdisplay: block;\n\tfont-size: 1.5em;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/App.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/App.css
// module chunks = 0